import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import MainCommonView from '../../../components/common/MainCommonView'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import useAccess from '../../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../../utils/constants/roles'
import useModal from '../../../utils/hooks/useModal'
import { SuppliersService } from '../../../services/purchase-fuel/suppliers/suppliers.service'
import DataTableComp from '../../../components/common/data-table/DataTableComp'
import editNumberRowColumn from '../../../components/common/data-table/editors/editNumberRowColumn'
import editTextRowColumn from '../../../components/common/data-table/editors/editTextRowColumn'
import Modal from '../../../components/modal/Modal'
import SuppliersForm from '../../../components/purchase-fuel/suppliers/SuppliersForm'
import rowDelete from '../../../components/common/data-table/column-types/rowDelete'
import rowEditor from '../../../components/common/data-table/column-types/rowEditor'
import {
  bodyPhoneInputMask,
  bodyRenderTypes,
} from '../../../components/common/data-table/column-types/ColumnTypes'
import './suppliers.scss'
import OwnCentersServices from '../../../services/own-centers/ownCenters.service'
import CenterService from '../../../services/centers/center.service'
import editMultiselectRowColumn from '../../../components/common/data-table/editors/editMultiselectRowColumn'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import { purchaseFuels } from '../../../utils/constants/navlinks-Menu'

const Suppliers = () => {
  const { formatMessage: msg } = useIntl()
  const { canAdd, canDelete, canEdit } = useAccess()
  const { isShowing, toggle } = useModal()

  const [provinces, setProvinces] = useState([])

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'code',
    getAll: SuppliersService.getAll,
    createAction: SuppliersService.create,
    editAction: SuppliersService.update,
    removeAction: SuppliersService.remove,
    rowsPerPageInitial: 100,
  })

  useEffect(() => {
    getProvinces()
  }, [])

  const getProvinces = async () => {
    const resp = await CenterService.getProvinces()

    if (resp) {
      setProvinces(formatProvinces(resp?.resp))
    }
  }

  const formatProvinces = (data) => {
    const result = data.map((item) => {
      const cleanItem = item.trim()
      return {
        label: cleanItem,
        value: cleanItem,
      }
    })
    return result
  }

  const handleCreate = async (data) => {
    await dataFacade.create(data)
    toggle()
  }

  const onRowEditComplete = async ({ newData }) => {
    await dataFacade.edit({ _id: newData?._id, body: newData })
  }

  const headerOptions = {
    title: msg({ id: 'purchase.suppliers' }),
    handlerHeaderActions: {
      secondaryButton:
        canAdd(MODULES.PURCHASE_FUEL, GROUPS.SUPPLIERS) && toggle,
      secondaryButtonText: 'button.add',
      secondaryButtonIcon: 'pi-plus',
    },
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        className: 'table-with-menu',
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        editMode: 'row',
        onRowEditComplete,
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column
          field="code"
          header={msg({ id: 'cod' })}
          {...editNumberRowColumn({})}
        />,
        <Column
          field="name"
          header={msg({ id: 'name' })}
          {...editTextRowColumn}
        />,
        <Column
          field="contact"
          header={msg({ id: 'contact' })}
          {...editTextRowColumn}
        />,
        <Column
          field="phone"
          body={(rowData) => bodyPhoneInputMask(rowData?.phone)}
          header={msg({ id: 'phone' })}
          {...editTextRowColumn}
        />,

        <Column
          field="email"
          header={msg({ id: 'email' })}
          {...editTextRowColumn}
        />,
        <Column
          field="prices"
          header={msg({ id: 'prices' })}
          {...editTextRowColumn}
        />,
        <Column
          field="pay"
          header={msg({ id: 'pay' })}
          {...editTextRowColumn}
        />,
        <Column
          field="provinces"
          header={msg({ id: 'provinces' })}
          body={(rowData) => bodyRenderTypes(rowData?.provinces)}
          {...editMultiselectRowColumn({
            options: provinces,
            optionLabel: 'value',
            optionValue: 'value',
          })}
        />,
        <Column
          field="others"
          header={msg({ id: 'remarks' })}
          {...editTextRowColumn}
        />,
        canDelete(MODULES.PURCHASE_FUEL, GROUPS.SUPPLIERS) && (
          <Column {...rowDelete({ handleDelete: dataFacade.remove })} />
        ),
        canEdit(MODULES.PURCHASE_FUEL, GROUPS.SUPPLIERS) && (
          <Column {...rowEditor()} />
        ),
      ]}
    />
  )

  return (
    <AppSection
      /* refactor this */
      header={<AppTabMenu options={purchaseFuels} breakpoint="xl" />}
      headerOptions={headerOptions}
    >
      {dataTable}
      <Modal
        isShowing={isShowing}
        hide={toggle}
        width="100%"
        maxWidth="900px"
        title={msg({ id: 'purchase.suppliers.new' })}
        context={<SuppliersForm handleSubmit={handleCreate} />}
      />
    </AppSection>
  )
}

export default Suppliers
